// GraphQL enum values (must match schema)
export enum RechargeType {
  SOCIAL_SPRINTER = 'SOCIAL_SPRINTER',
  STRUCTURED_SOCIALIZER = 'STRUCTURED_SOCIALIZER',
  SPONTANEOUS_SOLOIST = 'SPONTANEOUS_SOLOIST',
  DEEP_RESTORER = 'DEEP_RESTORER',
}

export interface QuizAnswers {
  q1: boolean // social
  q2: boolean // structured
  q3?: boolean // prefersShort (optional)
}

export interface RechargeTypeData {
  rechargeType: RechargeType
  completedAt: string
  quizAnswers: QuizAnswers
}

export interface RechargeTypeInfo {
  emoji: string
  tagline: string
  optimalPTO: string
  tips: string[]
}

export interface GameColleague {
  userId: string
  name: string
  imageUrl?: string
  department?: string
  rechargeType: RechargeType
}

// Simplified: only streak matters
export interface GameResult {
  streak: number // The streak achieved this game (before wrong answer ended it)
}

// Leaderboard ranked by bestStreak, tiebroken by earliest achievement date
export interface LeaderboardEntry {
  rank: number
  userId: string
  name: string
  imageUrl?: string
  bestStreak: number
  bestStreakDate: string // For tiebreaker - first to achieve wins
  gamesPlayed: number
}

// Simplified user stats - streak-based only
export interface UserGameStats {
  userId: string
  companyId: string
  bestStreak: number
  bestStreakDate: string // When the best streak was achieved
  gamesPlayed: number
  lastPlayedAt: string
}

export interface ChallengeInfo {
  quizCompletedCount: number
  requiredNumberOfUsers: number
  isUnlocked: boolean
}
